<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>ویرایش پیام پشتیبانی</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="3">
                                    <CTextarea v-model="form.message_text.val" :description="form.message_text.inv" label="پیام" rows="3"
                                        @keyup.enter="access=false" />
                                </CCol>
                            </CRow>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" color="primary"> ویرایش</CButton>
                        </div>    
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import validator from '../mixins'
export default {
    mixins: { validator },
    data() {
        return {
            form: {
				message_text: {val: '', inv: '', v: { req: true, max: 2048 }},
			},
            disable: false,
            access: true,
        }
    },
    mounted(){
        this.get_support_message();
    },
    methods: {
        get_support_message(){
            this.axios.get('conversations/'
                + '?id=' + this.$route.params.id)
                .then(res => {
                    res.data[0].conversation_messages.map(val => {
                        if(val.id == this.$route.params.mid){
                            this.form.message_text.val = String(val.message_text).replaceAll('&lt;br&gt;', '\n');
                        }
                    });
                })
        },
        submit(){
            if(this.access){
                if(this.disable == false){
                    const data = new FormData();
                    for (const key in this.form){
                        data.set(key, String(this.form[key].val).replaceAll('\n', '<br>'));
                    }
                    data.set('id', this.$route.params.mid);
                    this.axios.put('conversation_messages/', data)
                        .then(() => {
                            this.$notify({
                                group: 'foo',
                                type: 'success',
                                text: 'ویرایش با موفقیت انجام شد.'
                            });
                            this.$router.go(-1);
                        })
                        .catch(() => {
                            this.$notify({
                                group: 'foo',
                                type: 'error',
                                text: 'خطا! لطفا مجددا تلاش کنید.'
                            });
                        })
                }
            }
            this.access = true;
        },
    },
	beforeCreate(){
        if(this.$store.state.perms.can_user_update_last_user_messages_in_conversation == false
            && this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>
